/** 応募者の進捗ではなく、依頼の到達目標。操作可能なチェック欄にはしません。 */
export function QuestObjectives({
  objectives,
  compact = false,
}: {
  objectives: string[];
  compact?: boolean;
}) {
  if (objectives.length === 0) return null;
  return (
    <ol
      className={`jq-objectives${compact ? " is-compact" : ""}`}
      aria-label="Missionの到達目標"
    >
      {objectives.map((objective, index) => {
        const [label, ...rest] = objective.split(" / ");
        return (
          <li key={objective}>
            <span className="jq-objective-number" aria-hidden="true">
              {String(index + 1).padStart(2, "0")}
            </span>
            <div>
              {rest.length ? (
                <>
                  <span>{label}</span>
                  <p>{rest.join(" / ")}</p>
                </>
              ) : (
                <p>{label}</p>
              )}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
